import { render, staticRenderFns } from "./QuestionSuggestionCard.vue?vue&type=template&id=508fbef6&scoped=true"
import script from "./QuestionSuggestionCard.vue?vue&type=script&lang=ts"
export * from "./QuestionSuggestionCard.vue?vue&type=script&lang=ts"
import style0 from "./QuestionSuggestionCard.vue?vue&type=style&index=0&id=508fbef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508fbef6",
  null
  
)

export default component.exports